import { memo } from "react";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import { redirectToUrl } from "../utils/url/urlUtils";
import ToastMessage from "../common/components/Messages/ToastMessage/ToastMessage";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";

interface Props {
  errors: string[];
}

const ExpiredLinkPage = ({ errors }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="scha__registration-expired">
      {errors.map((err) => (
        <ToastMessage type={"error"} key={err}>
          {t(err)}
        </ToastMessage>
      ))}
      <PageTitle title={t("page.expiredLink.title")} />
      <div className="scha__registration-expired__info">{t("page.expiredLink.info")}</div>
      <Button data-test-id={"expired-registration-button"} onClick={() => redirectToUrl("/registered/user")}>
        {t("page.expiredLink.registerForFree")}
      </Button>
    </div>
  );
};

export default memo(ExpiredLinkPage);
